const idFilters = [
  "brand",
  "author",
  "label",
  "permissionGroup",
  "userSegment",
  "section",
  "category",
];

export default idFilters;



// WEBPACK FOOTER //
// ./src/state/idFilters.js